<template>
    <div class="" v-loader.opacity.tab="loading">
      <div class="title-box">
        <h2 class="title">{{ $t('clinic.editConsentTemplate') }}</h2>
      </div>

      <p class="section-observation">
        <strong>{{ $t('clinic.important') }}:</strong>
        {{ $t('clinic.consentObservation') }}
      </p>

      <vee-form v-slot="{ handleSubmit }" as="div">
        <form @submit.prevent.stop="handleSubmit(doSave)" @keydown.enter="$event.preventDefault()">

          <div class="consent-template-box scrollbar">
            <div class="row">
              <div class="col-lg-6">
                <div class="form-floating mb-3">
                  <vee-field name="name" v-model="template.name" rules="required" v-slot="{ field, errorMessage }">
                    <input v-bind="field" type="text" class="form-control" ref="name" id="ctName" :placeholder="$t('name')" autofocus>
                    <span class="vee-error">{{ errorMessage }}</span>
                  </vee-field>
                  <label for="ctName">{{ $t('name') }}*</label>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-floating mb-3">
                  <vee-field name="description" v-model="template.description" v-slot="{ field, errorMessage }">
                    <input v-bind="field" type="text" class="form-control" id="ctDescription" :placeholder="$t('description')">
                    <span class="vee-error">{{ errorMessage }}</span>
                  </vee-field>
                  <label for="ctDescription">{{ $t('description') }}*</label>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <!-- <p class="text-muted small mb-2">{{ $t('clinic.consentHtmlHint') }}</p> -->
              <quill-editor
                ref="quillEditor"
                class="editor clinic"
                v-model:content="content"
                :options="editorOption"
                content-type="html"
              />
            </div>

            <!-- TODO: I'll return in a second stage -->
            <!-- <div class="mb-3">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <label class="form-label fw-bold mb-0">{{ $t('clinic.consentFormFields') }}</label>
                <div class="d-flex gap-2">
                  <button type="button" class="btn btn-sm btn-outline-secondary" @click="syncFromContent">
                    <i class="fa fa-refresh me-1"></i> {{ $t('clinic.syncFromHtml') }}
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="addField">
                    <i class="fa fa-plus me-1"></i> {{ $t('clinic.addField') }}
                  </button>
                </div>
              </div>

              <div class="table-responsive" v-if="formSchema.length > 0">
                <table class="table table-sm table-bordered align-middle">
                  <thead class="table-light">
                    <tr>
                      <th style="width: 25%">{{ $t('clinic.fieldKey') }}</th>
                      <th style="width: 30%">{{ $t('clinic.fieldLabel') }}</th>
                      <th style="width: 20%">{{ $t('clinic.fieldType') }}</th>
                      <th style="width: 15%">{{ $t('clinic.fieldRequired') }}</th>
                      <th style="width: 10%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(field, index) in formSchema" :key="index">
                      <td>
                        <input type="text" class="form-control form-control-sm" v-model="field.key" placeholder="patient_name">
                      </td>
                      <td>
                        <input type="text" class="form-control form-control-sm" v-model="field.label" placeholder="Patient Name">
                      </td>
                      <td>
                        <select class="form-select form-select-sm" v-model="field.type">
                          <option value="text">Text</option>
                          <option value="date">Date</option>
                          <option value="textarea">Textarea</option>
                          <option value="checkbox">Checkbox</option>
                        </select>
                      </td>
                      <td class="text-center">
                        <input type="checkbox" class="form-check-input" v-model="field.required">
                      </td>
                      <td class="text-center">
                        <button type="button" class="btn btn-sm btn-outline-danger" @click="removeField(index)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="text-muted small p-3 text-center border rounded">
                {{ $t('clinic.noFieldsDefined') }}
              </div>
            </div> -->
          </div>

          <div class="action-bar">
            <!-- <button class="btn btn-success" v-if="hasFormChanged" type="submit" name="button">
              <span>{{ $t("save") }}</span>
            </button> -->
            <button class="btn btn-secondary" type="button" name="button" @click="$emit('cancel-edit')">
              <span>{{ $t('cancel') }}</span>
            </button>
          </div>
        </form>
      </vee-form>
    </div>
  </template>

  <style lang="scss" scoped>

  .section-observation {
    color:                            var(--Brand-Primary);
    padding:                          10px;
  }
  .consent-template-box {
    height:                           calc(100dvh - 449px) !important;
    padding:                          10px;
    overflow-y:                       auto;
    overflow-x:                       hidden;
  }

  .vee-error {
    width:                            100% !important;
  }

  .has-alert {
    .consent-template-box {
      height:                         calc(100dvh - 465px);
    }
  }

  @media (max-width: 1500px) {
    .has-alert {
      .consent-template-box {
        height:                       calc(100dvh - 459px);
      }
    }
  }

  @media (max-width: 991px) {
    .consent-template-box {
      height:                         calc(100dvh - 309px);
      overflow-x:                     hidden;
      overflow-y:                     scroll;
    }

    .has-alert {
      .consent-template-box {
        height:                       calc(100dvh - 399px);
      }
    }

    .has-usage-bar {
      .consent-template-box {
        height:                       calc(100dvh - 356px);
      }
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1365px) {
    .consent-template-box {
      height:                         calc(100dvh - 358px);
      overflow-x:                     hidden;
      overflow-y:                     scroll;
    }
  }
  </style>

  <script>
  import { useUserStore } from '@/store/user'

  const SYSTEM_PLACEHOLDERS = ['patient_signature_img', 'signature_date', 'witness_signature_img', 'witness_date'];

  const toolbarOptions = [
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }]
  ];

  export default {
    props: ['template_id'],
    name: 'ClinicConsentTemplateEdit',
    data: () => ({
      loading: false,
      editorOption: {
        modules: {
          toolbar: toolbarOptions
        },
        theme: 'snow',
      },
      template: {
        id: null,
        name: null,
        description: null,
        htmlContent: null,
      },
      content: null,
      formSchema: [],
      required: false,
      hasFormChanged: false,
      changedFormItems: [],
      initialForm: {},
    }),
    watch: {
      template_id: {
        immediate: true,
        handler: function (template_id) {
          if (template_id && this.session) {
            this.fetchData()
          }
          this.$nextTick(() => {
            this.hasFormChanged = false
            this.changedFormItems = []
          })
        }, deep: true
      },
      template: {
        immediate: true,
        handler: function(newValue) {
          this.checkFormChange(newValue, 'template')
        }, deep: true
      },
      content: {
        immediate: true,
        handler: function(newValue) {
          this.checkFormChange(newValue, 'content')
        }, deep: true
      },
      formSchema: {
        immediate: true,
        handler: function(newValue) {
          this.checkFormChange(newValue, 'formSchema')
        }, deep: true
      },
    },
    computed: {
      editor() {
        return this.$refs.quillEditor.quill;
      }
    },
    mounted: function() {
      const userStore = useUserStore();
      this.session = userStore.sessionInfo;

      if (this.template_id) {
        this.template.id = this.template_id
        this.fetchData()
      }
    },
    methods: {
      checkFormChange(value, obj) {
        let hasObj = this.changedFormItems.includes(obj)
        if (JSON.stringify(value) === JSON.stringify(this.initialForm[obj])) {
          if (hasObj) {
            let index = this.changedFormItems.indexOf(obj)
            this.changedFormItems.splice(index, 1)
          }
          if (this.changedFormItems.length > 0) return
          this.hasFormChanged = false
        } else {
          if (!hasObj) this.changedFormItems.push(obj)
          this.hasFormChanged = true
        }
      },
      async fetchData() {
        this.loading = true
        NProgress.start()
        try {
          let response = await this.$clinicService.getConsentTemplate({
            clinicID: this.session.currentClinic.id,
            templateID: this.template_id
          });
          const result = response.result
          this.setTemplate(result)
        } catch (err) {
          console.log("Error in fetchData", err)
          this.$message.popup(this, 'request_error', 'operationFail', 'error')
        } finally {
          NProgress.done(true)
          this.loading = false
        }
      },
      setTemplate(result) {
        this.template = result;

        this.content = String(result.htmlContent);

        this.$refs.quillEditor.setHTML(this.content)

        this.initialForm = _.cloneDeep({
          template: this.template,
          content: this.content,
          formSchema: this.formSchema,
        })
      },
      async doSave() {
        let params = {
          clinicID: this.session.currentClinic.id,
          template: {
            name: this.template.name,
            description: this.template.description,
            htmlContent: this.content,
            formSchema: this.formSchema,
          }
        }

        if (this.template.id) {
          params.template.id = this.template.id
        }

        this.loading = true
        NProgress.start()
        try {
          await this.$clinicService.saveConsentTemplate(params);
          this.$message.popup(this, 'general.createdSuccess', 'operationSuccess', 'success')
          this.$emit('cancel-edit')
        } catch(err) {
          this.$message.popup(this, 'general.createdError', 'operationFail', 'error')
        } finally {
          NProgress.done(true)
          this.loading = false
        }

      },
      addField() {
        this.formSchema.push({ key: '', label: '', type: 'text', required: false })
      },
      removeField(index) {
        this.formSchema.splice(index, 1)
      },
      syncFromContent() {
        const html = this.content || ''
        const matches = html.match(/\{\{(\w+)\}\}/g) || []
        const existingKeys = this.formSchema.map(f => f.key)

        for (const match of matches) {
          const key = match.replace(/\{\{|\}\}/g, '')
          if (SYSTEM_PLACEHOLDERS.includes(key)) continue
          if (existingKeys.includes(key)) continue

          this.formSchema.push({
            key: key,
            label: key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
            type: 'text',
            required: false
          })
          existingKeys.push(key)
        }
      },
    },
  }
  </script>
